import React, { useState } from 'react';
import { styles } from '../../styles/theme';

const variables = [
  { name: '{nome}', description: 'Nome do cliente (ambos os tipos)', example: 'Joao Silva' },
  { name: '{produto}', description: 'Nome do produto/servico (ambos)', example: 'Curso Online' },
  { name: '{data_vencimento}', description: 'Data de vencimento (ambos)', example: '15/01/2025' },
  { name: '{data_primeira_parcela}', description: 'Data do primeiro pagamento (ambos)', example: '15/01/2025' },
  { name: '{valor_total}', description: 'Apenas Parcelado: valor total do contrato', example: 'R$ 1.200,00' },
  { name: '{num_parcelas}', description: 'Apenas Parcelado: numero total de parcelas', example: '12' },
  { name: '{total_parcelas}', description: 'Apenas Parcelado: alias para num_parcelas', example: '12' },
  { name: '{parcela_num}', description: 'Apenas Parcelado: numero da parcela atual', example: '3' },
  { name: '{valor_parcela}', description: 'Apenas Parcelado: valor de cada parcela', example: 'R$ 100,00' },
  { name: '{valor_mensal}', description: 'Apenas Recorrente: valor da mensalidade', example: 'R$ 2.500,00' },
];

const TemplateVariablesHelp = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div style={{
      backgroundColor: '#161b22',
      border: '1px solid #30363d',
      borderRadius: '8px',
      marginBottom: '16px',
      overflow: 'hidden'
    }}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          width: '100%',
          padding: '12px 16px',
          backgroundColor: 'transparent',
          border: 'none',
          color: '#58a6ff',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          textAlign: 'left'
        }}
      >
        <span>? Variaveis disponiveis para templates</span>
        <span style={{
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s'
        }}>
          v
        </span>
      </button>

      {isExpanded && (
        <div style={{ padding: '0 16px 16px' }}>
          <p style={{
            color: '#7d8590',
            fontSize: '13px',
            marginBottom: '12px',
            margin: '0 0 12px 0'
          }}>
            Use estas variaveis em seus templates de email. Elas serao substituidas automaticamente pelos valores reais.
          </p>

          <div style={{
            display: 'grid',
            gap: '8px'
          }}>
            {variables.map((variable) => (
              <div
                key={variable.name}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '140px 1fr 120px',
                  gap: '12px',
                  padding: '8px 12px',
                  backgroundColor: '#0d1117',
                  borderRadius: '6px',
                  fontSize: '13px',
                  alignItems: 'center'
                }}
              >
                <code style={{
                  color: '#58a6ff',
                  backgroundColor: '#21262d',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontFamily: 'Monaco, monospace'
                }}>
                  {variable.name}
                </code>
                <span style={{ color: '#c9d1d9' }}>
                  {variable.description}
                </span>
                <span style={{ color: '#7d8590', fontStyle: 'italic' }}>
                  Ex: {variable.example}
                </span>
              </div>
            ))}
          </div>

          <div style={{
            marginTop: '16px',
            padding: '12px',
            backgroundColor: '#0d1117',
            borderRadius: '6px',
            border: '1px solid #30363d'
          }}>
            <strong style={{ color: '#f0f6fc', fontSize: '13px' }}>Dica:</strong>
            <p style={{
              color: '#7d8590',
              fontSize: '13px',
              margin: '8px 0 0 0'
            }}>
              Voce pode copiar as variaveis clicando nelas e colar diretamente no seu template.
              Certifique-se de manter as chaves {'{ }'} ao redor do nome da variavel.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplateVariablesHelp;
